import Chapitre from "./Chapitre";
export default Chapitre;
